export default __webpack_public_path__ + "static/media/mac_mini.4a28060c.svg";